import { render } from "./Transacteuro.vue?vue&type=template&id=6ab1c264"
import script from "./Transacteuro.vue?vue&type=script&lang=js"
export * from "./Transacteuro.vue?vue&type=script&lang=js"

import "./Transacteuro.vue?vue&type=style&index=0&id=6ab1c264&lang=css"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__